import * as React from 'react';

export const  Html =()=> (
  <svg enable-background="new 0 0 126 126" version="1.1" viewBox="0 0 601 600" xmlns="http://www.w3.org/2000/svg">
 <g stroke-width=".08">
  <polygon transform="matrix(12 0 0 12 -468 -325)" points="81 31 78 68 63 72 48 68 45 31" fill="#e34c26"/>
  <polygon transform="matrix(12 0 0 12 -468 -325)" points="63 69 75 65 78 34 63 34" fill="#f06529"/>
  <polygon transform="matrix(12 0 0 12 -468 -325)" points="68 58 63 59 58 58 58 54 53 54 54 61 63 64 72 61 74 47 57 47 57 43 74 43 74 43 74 38 52 38 53 52 69 52" fill="#fff"/>
  <polygon transform="matrix(12 0 0 12 -468 -325)" points="63 43 63 38 52 38 53 52 63 52 63 47 57 47 57 43" fill="#ebebeb"/>
  <polygon transform="matrix(12 0 0 12 -468 -325)" points="63 64 63 59 63 59 58 58 58 54 53 54 54 61 63 64" fill="#ebebeb"/>
 </g>
</svg>
)
